export default __webpack_public_path__ + "static/media/151-blocked.5842e88f.png";